import React from "react";
import ContactNewMeet from "../components/contact/ContactNewMeet";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";


export default function ContactUs() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader PageTitle="Quiero una reunión" Parent="Contacto" HeaderTitle="Quiero una reunión"/>
      <ContactNewMeet />
      <Footer/>
    </Layout>
  );
}
